import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
	Container,
	SpaceBetween,
	FlashbarProps,
} from '@amzn/awsui-components-console';

import GenericWizard from 'src/components/commonComponents/GenericWizard/GenericWizard';
import { generateReviewSectionsFromSteps } from 'src/components/commonComponents/GenericWizard/utils/wizardUtils';

import {
	OperationProfileFormMetadata,
	getOperationWizardSteps,
} from './OperationFormGenerationUtils';

interface AddOperationPageFormProps {
	onCancel: () => void;
	onSubmit: (data: OperationProfileFormMetadata) => void;
	applicationName: string;
	isLoading: boolean;
	errorMessage?: string | null;
	flashBarItems?: FlashbarProps.MessageDefinition[];
}

export default function AddOperationPageForm({
	onCancel,
	onSubmit,
	applicationName,
	isLoading,
	errorMessage,
	flashBarItems,
}: AddOperationPageFormProps) {
	const { watch, setValue } = useFormContext<OperationProfileFormMetadata>();
	const useServiceNamespaceAsOperationNamespace = watch('useServiceNamespaceAsOperationNamespace');
	const serviceNamespace = watch('serviceNamespace');

	useEffect(() => {
		if (useServiceNamespaceAsOperationNamespace === 'true') {
			setValue('operationNamespace', serviceNamespace);
		}
	}, [useServiceNamespaceAsOperationNamespace, serviceNamespace, setValue]);

	return (
		<GenericWizard<OperationProfileFormMetadata>
			title="Add Operation"
			description="Create a new operation for your application"
			steps={getOperationWizardSteps({ useServiceNamespaceAsOperationNamespace, serviceNamespace })}
			onCancel={onCancel}
			onSubmit={onSubmit}
			isLoading={isLoading}
			errorMessage={errorMessage}
			flashBarItems={flashBarItems}
			reviewTitle="Review Operation Details"
			submitButtonText="Create Operation"
			generateReviewSections={generateReviewSectionsFromSteps}
			additionalContent={
				<Container>
					<SpaceBetween size="s">
						<div>Application: {applicationName}</div>
					</SpaceBetween>
				</Container>
			}
		/>
	);
}
